import { ENV_VARS } from 'constants/environment.constants';
import { kf1AuthenticatedHttpClient } from 'kfone-frontend-core';
import type { RtiTemplateApiResponse } from 'model/interfaces/rti-template';

const RTI_GET_TEMPLATE_PATH = 'rti/getrtitemplate';

export const RTI_TEMPLATE_VERSION_DEFAULT = 1;

let inFlightGet: Promise<RtiTemplateApiResponse> | null = null;

export const getRtiTemplate = async (): Promise<RtiTemplateApiResponse> => {
  if (inFlightGet) {
    return inFlightGet;
  }

  inFlightGet = kf1AuthenticatedHttpClient({
    baseURL: ENV_VARS.API_URL,
    url: RTI_GET_TEMPLATE_PATH,
    method: 'GET',
  })
    .then((res) => res.data as RtiTemplateApiResponse)
    .finally(() => {
      queueMicrotask(() => {
        inFlightGet = null;
      });
    });

  return inFlightGet;
};
